export default "__VITE_ASSET__Cfadn3Z4__"